import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "currentColor",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M12.8889 6H9.33333C8.59695 6 8 6.57999 8 7.29545V23.7045C8 24.42 8.59695 25 9.33333 25H12.8889C13.6253 25 14.2222 24.42 14.2222 23.7045V7.29545C14.2222 6.57999 13.6253 6 12.8889 6Z" }), /* @__PURE__ */ _jsx("path", { d: "M22.6667 6H19.1111C18.3747 6 17.7778 6.57999 17.7778 7.29545V23.7045C17.7778 24.42 18.3747 25 19.1111 25H22.6667C23.403 25 24 24.42 24 23.7045V7.29545C24 6.57999 23.403 6 22.6667 6Z" })]
});
export { SvgPause as ReactComponent };
